import React, {ChangeEvent, useEffect, useState} from "react";
import logo from "../../../assets/img/logo.svg";
import { Button, StandaloneFormPage, Text, Form } from "tabler-react";
import {validatePassword} from "../../../utils/validatePassword";
import {useAuth} from "../../../hooks/AuthContext";
import {Alerta} from "../../../utils/Alerta";
import {useHistory} from "react-router-dom";

interface CredentialsResetFormProps {
  email: string;
  password: string;
}

export function PasswordResetForm() {
  const history = useHistory();
  const [disableButton , setDisableButton] = useState(true);
  const [newPassword, setNewPassword] = useState<string>("");
  const [passwordError, setPasswordErr] = useState<string[]>([]);
  const [confirmNewPassword, setConfirmNewPassword] = useState<string>(" ");

  const { signIn, email, passwordTmp, store } = useAuth();

  async function handleLogin(email?: string, newPassword?: string, currentPassword?: string) {
    try {
      await signIn({
        email: email,
        password: currentPassword,
        newPassword: newPassword,
      });

      Alerta("Senha redefinida com sucesso!", "success");

      if(!!store && !!store.id) {
        history.push('dashboard')
      }
    } catch (err) {
      Alerta("Erro ao tentar redefinir senha");
    }
  }

  const handleConfirmPasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
    const confirmNewPasswordValue = event.currentTarget.value;
    setConfirmNewPassword(confirmNewPasswordValue);
    setPasswordErr(validatePassword(newPassword, confirmNewPasswordValue));
  };

  const handlePasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newPasswordValue = event.currentTarget.value;
    setNewPassword(newPasswordValue);
    setPasswordErr(validatePassword(newPasswordValue, confirmNewPassword));
  };

  const formattedPasswordErrors = passwordError.map((message, index) => (
    <Text key={index} color={"red"}>{message}</Text>
  ));

  useEffect(() => {
    if (passwordError.length === 0 && !!newPassword) {
      setDisableButton(false)
    }
  }, [newPassword, passwordError]);

  return <StandaloneFormPage
    imageURL={logo}
    children={
      <Form className="form-name">
        <Form.Group label="Email" className="form-reset">
          <Form.Input
            name="email"
            value={email}
            disabled
            type="email"
          />
        </Form.Group>
        <Form.Group label="Nova Senha" className="form-reset">
          <Form.Input
            placeholder="Digite sua nova senha"
            name="password"
            onChange={handlePasswordChange}
            error={passwordError.length > 0 ? " " : ""}
            type="password"
          />
        </Form.Group>
        <Form.Group label="Digite a nova senha novamente" className="form-reset">
          <Form.Input
            placeholder="Digite sua nova senha novamente"
            onChange={handleConfirmPasswordChange}
            name="confirmPassword"
            error={passwordError.length > 0 ? " " : ""}
            type="password"
          />
        </Form.Group>
        {formattedPasswordErrors}
        <Button
          size="sm"
          href="#"
          RootComponent="a"
          color="primary"
          onClick={() => handleLogin(email, newPassword, passwordTmp)}
          className="button-store"
          disabled={disableButton}
        >
          Login
        </Button>
      </Form>
    }
  />
}